export default function NotFound(props) {
  return (
    <main>
      <div style={{ padding: '10px' }}>
        <p>Page Not Found!</p>
      </div>
    </main>
  );
}
